

































































































































export enum FILTER_TEXT_ENUM {
  EqualTo = 'equal_to',
  NotEqualTo = 'not_equal_to',
  StartsWith = 'starts_with',
  Contains = 'contains',
  NotContain = 'not_ontains',
  EndsWith = 'ends_with',
}

export enum FILTER_NUMBER_ENUM {
  EqualTo = 'equal_to',
  NotEqualTo = 'not_equal_to',
  GreaterThanOrEqualTo = 'greater_than_or_equal_to',
  GreaterThan = 'greater_than',
  LessThanOrEqualTo = 'less_than_or_equal_to',
  LessThan = 'less_than',
}

export enum FILTER_DATE_ENUM {
  EqualTo = 'equal_to',
  NotEqualTo = 'not_equal_to',
  AfterOrEqualTo = 'after_or_equal_to',
  After = 'after',
  BeforeOrEqualTo = 'before_or_equal_to',
  Before = 'before',
}

import {Vue, Component, Prop} from 'vue-property-decorator';
/*custom filter component for handling filtering
  prop: header- take column field details
  emit: clearFilter to reset filter
  emit: filterParams with data selected in form
*/
@Component
export default class FilterMenu extends Vue {
  @Prop()
  public header!: any;

  firstSelect = FILTER_TEXT_ENUM.EqualTo;
  secondSelect = FILTER_TEXT_ENUM.EqualTo;
  operationType = 'And';
  param1 = '';
  param2 = '';

  public equalTo = [
    {
      displayName: 'Is equal To',
      value: FILTER_TEXT_ENUM.EqualTo,
    },
    {
      displayName: 'Is not equal To',
      value: FILTER_TEXT_ENUM.NotEqualTo,
    },
    {
      displayName: 'Starts with',
      value: FILTER_TEXT_ENUM.StartsWith,
    },
    {
      displayName: 'Contains',
      value: FILTER_TEXT_ENUM.Contains,
    },
    {
      displayName: 'Does not contain',
      value: FILTER_TEXT_ENUM.NotContain,
    },
    {
      displayName: 'Ends with',
      value: FILTER_TEXT_ENUM.EndsWith,
    },
  ];

  public equalToNumber = [
    {
      displayName: 'Is equal To',
      value: FILTER_NUMBER_ENUM.EqualTo,
    },
    {displayName: 'Is not equal To', value: FILTER_NUMBER_ENUM.NotEqualTo},
    {
      displayName: 'Is greater than or equal to',
      value: FILTER_NUMBER_ENUM.GreaterThanOrEqualTo,
    },
    {displayName: 'Is greater than', value: FILTER_NUMBER_ENUM.GreaterThan},
    {
      displayName: 'Is less than or equal to',
      value: FILTER_NUMBER_ENUM.LessThanOrEqualTo,
    },
    {displayName: 'Is less than', value: FILTER_NUMBER_ENUM.LessThan},
  ];

  public equalToDate = [
    {
      displayName: 'Is equal To',
      value: FILTER_DATE_ENUM.EqualTo,
    },
    {displayName: 'Is not equal To', value: FILTER_DATE_ENUM.NotEqualTo},
    {
      displayName: 'Is after or equal To',
      value: FILTER_DATE_ENUM.AfterOrEqualTo,
    },
    {displayName: 'Is after', value: FILTER_DATE_ENUM.After},
    {
      displayName: 'Is before or equal To',
      value: FILTER_DATE_ENUM.BeforeOrEqualTo,
    },
    {displayName: 'Is before', value: FILTER_DATE_ENUM.Before},
  ];

  public operationMode = ['And', 'Or'];
  filterParams = {};

  showAllFilters() {
    this.filterParams = {
      column: this.header.value,
      firstSelect: this.firstSelect,
      secondSelect: this.secondSelect,
      operationType: this.operationType,
      firstValue: this.param1,
      secondValue: this.param2,
    };

    this.$emit('filterParams', this.filterParams);
    this.closeDropDown();
  }
  closeDropDown() {
    const button: any = this.$refs.toggleButton;
    button.click();
  }

  clearFilter() {
    this.param1 = '';
    this.param2 = '';
    this.$emit('clearFilter', true);
    this.closeDropDown();
  }

  onSelectChange(event: any) {
    event.stopPropagation();
  }
}
